import React, { useState ,useRef  } from 'react';
import emailjs from 'emailjs-com';
import "bootstrap/dist/css/bootstrap.min.css";
// eslint-disable-next-line
import i18n from "../../../i18n";
import { useTranslation } from 'react-i18next';
import { Form, Row , Col ,InputGroup ,Button} from 'react-bootstrap';

const ContactUs = () => {
    const { t, i18n } = useTranslation();

    const [validated, setValidated] = useState(false);
    const form = useRef();
    
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            
        }
        setValidated(true);
        if (form.checkValidity() === true) {
            sendEmail(event);
            alert('massege send sucessfuly')
        }
    };

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_q4fjf1l', 'template_zvq476b', form.current, 'user_a5ssQEqOdOOJ69IJ81nJo')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };

    return (
        <Form noValidate validated={validated} ref={form} onSubmit={handleSubmit}>
        <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="validationCustom01">
                <Form.Label>{t('Your_Name')}</Form.Label>
                <Form.Control name="name" required type="text" placeholder="Name" />
                <Form.Control.Feedback>{t('Looks_good!')}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationCustom02">
                <Form.Label>{t('Phone')}</Form.Label>
                <Form.Control  name="phone" required type="number" placeholder="0912345678" />
                <Form.Control.Feedback>{t('Looks_good!')}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                <Form.Label>{t('Your_Email')}</Form.Label>
                <InputGroup hasValidation>
                    <InputGroup.Text id="inputGroupPrepend">{t('Email')}</InputGroup.Text>
                    <Form.Control type="email"  name="email" placeholder="Email@example.com" aria-describedby="inputGroupPrepend" required />
                    <Form.Control.Feedback type="invalid">
                    {t('Please_choose_an_Email')}
                    </Form.Control.Feedback>
                </InputGroup>
            </Form.Group>
        </Row>
        
        <Form.Group className="mb-3">
        <Form.Control as="textarea" name="message" placeholder="Leave a comment here" style={{ height: '100px' }}/>
        </Form.Group>
        <Button type="submit" value="Send" >{t('send_message')}</Button>
    </Form>
    )
}

export default ContactUs
